import Button from "@mui/material/Button";
import { SideDrawer } from "../../component/SideDrawer/SideDrawer";
import DashboardQRCard from "./DashboardqrCard";
import { useState } from "react";
import { useQrAuth } from "../../context/QrAuth";
import EditProfileForm from "./EditProfileForm";
import moment from "moment/moment";
import { useNavigate } from "react-router-dom";

export default function QrDashboard() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { logout, user } = useQrAuth()
  const navigate = useNavigate()
  // console.log("dfghjkkjhzxfg ==>>>", user)

  if(!user){
    navigate('/contact-card/login')
  }

 

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header */}
      <div className="bg-white shadow px-6 py-4 flex justify-between items-center">
        <h1 className="text-xl font-bold">Hi {user?.name}</h1>
        <Button
          size="medium"
          sx={{
            backgroundColor: '#8f77c6',
            color: 'white',
            '&:hover': {
              backgroundColor: '#7a65ad', // slightly darker shade
              color: 'white'
            }
          }}
          onClick={() => logout()}
        >
          Logout
        </Button>

      </div>

      {/* Content */}
      <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Left Column */}
        <div className="bg-white rounded-lg shadow p-6 space-y-4 pt-6 " >
          {/* QR Card */}
          <DashboardQRCard />
        </div>


        {/* Right Column */}
        <div className="space-y-6">
          {/* Profile Card */}
          <div className="flex flex-row items-start justify-between bg-white rounded-lg shadow p-6">
            <div className="flex items-center gap-4 mb-4">

              <div>
                <h2 className="text-lg font-bold">{user?.name}</h2>
                <p className="text-gray-600">{user?.title}</p>

                <div>
                  <h2 className="text-lg font-bold mb-1">Company Name</h2>
                  <p className="text-gray-500">{user?.company}</p>
                </div>
              </div>
            </div>
            <Button
              variant="outlined"
              size="small"
              className="!border-[#8f77c6] !text-[#8f77c6]"
              onClick={() => setDrawerOpen(true)}
            >
              Edit Profile
            </Button>
          </div>

          {/* Username + Company */}
          <div className="bg-white rounded-lg shadow p-6 space-y-4">
            <div>
              <div className="flex flex-row items-start justify-between">
                <h2 className="text-lg font-bold mb-2">Validity</h2>
                <Button
                  variant="outlined"
                  size="small"
                  className="!border-[#8f77c6] !text-[#8f77c6]"
                >
                  Renew
                </Button>
              </div>
              <p className="text-gray-700">
                {moment(user?.validityFrom).format("DD-MM-YYYY")} to  {moment(user?.validityTo).format("DD-MM-YYYY")}</p>
            </div>
          </div>

          {/* Contact Info */}
          <div className="bg-white rounded-lg shadow p-6 space-y-4 ">
            <div>
              <h2 className="text-lg font-bold mb-1">Email</h2>
              <p className="text-gray-700">{user?.email}</p>
            </div>
            <div>
              <h2 className="text-lg font-bold mb-1">Phone Number</h2>
              <p className="text-gray-700">{user?.telephone}</p>
            </div>
            <div>
              <h2 className="text-lg font-bold mb-1">Address</h2>
              <p className="text-gray-700">{user?.address}</p>
            </div>
            <div>
              <h2 className="text-lg font-bold mb-1">LinkedIn</h2>
              <a
                href={user?.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 underline"
              >
                {user?.linkedin}
              </a>
            </div>
            <div>
              <h2 className="text-lg font-bold mb-1">Website</h2>
              <a
                href={user?.website}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 underline"
              >
                {user?.website}
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Side Drawer for Editing */}
      <SideDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        title="Edit Profile"
        customWidth={true}

      >
        <div className="p-6"> <EditProfileForm setDrawerOpen={setDrawerOpen} /> </div>
      </SideDrawer>
    </div>
  );
}
